
// import { mapState } from 'vuex'
import userComment from '~/components/user/evaluationList.vue'
import Loadtab from '~/components/common/Loadtab.vue'
import reportPop from '~/components/discover/reportPop.vue' // 举报
export default {
  components: { 'report-pop': reportPop, 'user-comment': userComment, Loadtab },
  inject: ['main'],
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    report: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      grade: 0,
      list: this.result.list,
      total: this.result.showTotal,
      ladtabshow: false,
      reportCode: '' // 举报code
    }
  },
  methods: {
    tabgrade(val, index) {
      this.grade = val
      this.ladtabshow = true
      this.$api.common
        .CV3(
          {
            pageIndex: 1,
            code: this.main.main.code,
            userLoginId: this.$store.state.user.userId || '',
            searchType: val,
            pageSize: 2
          },
          {
            Routes: 'wikicommunity$fxgradepagelist'
          }
        )
        .then((res) => {
          console.log(res, 443)
          this.ladtabshow = false
          const r = res?.wikicommunity?.fxgradepagelist?.data || {}
          this.list = r.list || []
          this.total = r.showTotal || 0
          if (index) this.getelefn(index)
        })
    },
    getelefn(index) {
      const ele = document.getElementsByClassName('gradeele')
      const tagBox = document.getElementById('tagBox').clientWidth / 2
      const gradeBox = document.getElementById('gradeBox').clientWidth
      if (gradeBox <= tagBox * 2) return
      const w = ele[index].offsetLeft - tagBox
      if (w > 0) {
        document.getElementById('gradeBox').style.transform = `translateX(-${w}px)`
      } else {
        document.getElementById('gradeBox').style.transform = 'translateX(0px)'
      }
    },
    reportFn(code) {
      this.reportcode = code
      this.$refs.reportpop.setreportPop()
    },
    async reportseal(reportInfo) {
      // 调解列表举报提交
      const parm = {
        postsId: this.reportcode,
        userId: this.$store.state.user.userId ? this.$store.state.user.userId : '',
        reasonCode: reportInfo.code
      }
      const res = await this.$api.common
        .CV3(parm, {
          Routes: 'wikicommunity$postsreport'
        })
        .catch((err) => {
          this.$fxlog(`评价列表举报提交异常,${err},入参:${JSON.stringify(parm)},返回:${JSON.stringify(res)}`, window.location.href, this.$store.state.LanguageCode, '', res && res.message && !res.succeed ? 'ERROR' : '')
        })

      if (res?.wikicommunity?.postsreport?.success) {
        this.$message({
          message: this.$v('举报成功'),
          type: 'success',
          duration: 1500
        })
        this.$refs.reportpop.setreportPop()
      }
    }
  }
}
